"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var LoadMoreLoader = function LoadMoreLoader() {
  var _useTable = (0, _context.useTable)(),
      loadingMoreText = _useTable.loadingMoreText,
      footerHeight = _useTable.footerHeight,
      footerRenderer = _useTable.footerRenderer;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "load-more-overlay",
    style: {
      bottom: footerRenderer ? "".concat(footerHeight + 16, "px") : "16px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, loadingMoreText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-spinner-border oui-spinner-border-sm oui-ml-2",
    role: "status"
  }));
};

var _default = LoadMoreLoader;
exports["default"] = _default;